import * as angular from 'angular';
import {ConfigScope} from "./config.base";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsEnums} from "../../shared/dto/aps.enums";
import template from './flexIsConfig.tpl.html';
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";

interface FlexIsConfigScope extends ConfigScope {
  versions: EnumOption[];
  lineServers: apsViewModels.EquipmentDetail[];
}

export default angular.module('aps.controller.flexIsConfig', [])
  .directive('apsFlexIsConfig', (uiUtilityService: UIUtilityService): angular.IDirective => {
    return {
      restrict: 'E',
      template: template,
      link: (scope: FlexIsConfigScope) => {
        scope.lineServers = scope.vm.allEquipment.filter(e => e.type === apsEnums.EquipmentType.LineServer);
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/equipment/flexIsConfig.directive.ts